import { render, staticRenderFns } from "./ClientDraft.vue?vue&type=template&id=56ffd7fd"
import script from "./ClientDraft.vue?vue&type=script&lang=js"
export * from "./ClientDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports